// extracted by mini-css-extract-plugin
module.exports = {"main__content":"_layout_main__content__PqPCj"};